"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidDataService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
const bid_data_rollup_service_1 = require("./bid-data-rollup.service");
const data_level_service_1 = require("./data-level.service");
const data_metric_service_1 = require("./data-metric.service");
const loading_service_1 = require("./loading.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const permission_service_1 = require("./permission.service");
const router_1 = require("@angular/router");
const Subject_1 = require("rxjs/Subject");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
let BidDataService = class BidDataService {
    // Public setters for dashboard.component.ts
    setHasHadData(val) {
        this.hasHadData = val;
    }
    // Public setters for dashboard.component.ts
    setBidData(data) {
        this.bidData = data;
    }
    constructor(_http, _talk, _filter, _dataLevel, _rollup, _dataMetric, _ar, _router, _permission, _loading) {
        this._http = _http;
        this._talk = _talk;
        this._filter = _filter;
        this._dataLevel = _dataLevel;
        this._rollup = _rollup;
        this._dataMetric = _dataMetric;
        this._ar = _ar;
        this._router = _router;
        this._permission = _permission;
        this._loading = _loading;
        //data
        this.bidDataURL = "/dashboard/getdatagrouped?";
        this.createQueryURL = "/dashboard/create/query";
        this.createExportURL = "/dashboard/create/export";
        this.exportDataURL = "/dashboard/export";
        this.reportURL = "/report";
        this.universalColumnsRequired = "";
        this.bidData = [];
        this.totalBidData = {};
        this.bidDataValid = null;
        this.dashboardChartData = [];
        this.revenue = 0;
        this.adRenders = 0;
        this.adRendersECPM = 0;
        this.adFillRate = 0;
        // private adFillRateAvg:number=0;	// for validating vs adFillRate (median)
        this.hasHadData = false;
        this.rollup = new Subject_1.Subject();
        this.showQueryErrorAlert = false;
        this.showQueryTimeoutAlertMsg = false;
        this.showCountsAlertMsg = false;
        //chart styles
        this.revenueColor = "#9eb33f";
        this.adRendersColor = "#2387c5";
        this.adRendersECPMColor = "#a4b0f5";
        this.backgroundColor = "#fff";
        this.colorScheme = {
            domain: [
                this.revenueColor,
                this.adRendersColor,
                this.adRendersECPMColor,
                this.backgroundColor,
            ],
        };
        this.dataRanges = [
            "Today",
            "Yesterday",
            "Last 7 Days",
            "Last 30 Days",
            "This Month",
            "Last Month",
            "Custom",
        ];
        this.domains = [];
        this.adUnits = [];
        this.sizes = [];
        this.demandPartners = [];
        this.client_id = [];
        this.filters = "";
        this.cumulative = true;
        //initializations
        this.filtersURL = "/filter";
        //to enable/disable exportFileType
        this.csvWriter = false;
    }
    getUniversalColumnsRequiredQS() {
        return this._dataMetric
            .getNonGroupingMetrics()
            .reduce((colsStr, metric) => {
            colsStr += `&col=${metric.slug}`;
            return colsStr;
        }, "");
    }
    getUniversalColumnsRequiredJSON() {
        return this._dataMetric
            .getNonGroupingMetrics()
            .map((metric) => metric.slug);
    }
    getBidData() {
        return this.bidData ? JSON.parse(JSON.stringify(this.bidData)) : [];
    }
    getBidDataValid() {
        if (!this.bidDataValid) {
            this.bidDataValid = this.getBidData().filter((b) => !b.bidder ||
                b.data_source.includes("rtbx") ||
                b.data_source.includes("deals") ||
                this._filter
                    .getFilterLocalDataValues("bidder", "biddr", true)
                    .some((bidder) => bidder.value === b.bidder.toLowerCase()));
        }
        return this.bidDataValid;
    }
    getChartData() {
        return this.dashboardChart && this.dashboardChart.length
            ? JSON.parse(JSON.stringify(this.dashboardChart))
            : [];
    }
    getColorScheme() {
        return this.colorScheme;
    }
    getRevenue() {
        return this.totalBidData &&
            typeof this.totalBidData.dfp_revenue !== "undefined"
            ? this.totalBidData.dfp_revenue
            : 0;
    }
    getAdRenders() {
        return this.totalBidData && typeof this.totalBidData.renders !== "undefined"
            ? this.totalBidData.renders
            : 0;
    }
    getAdRendersECPM() {
        return this.totalBidData && typeof this.totalBidData.ecpm !== "undefined"
            ? this.totalBidData.ecpm
            : 0;
    }
    getInterval() {
        return this.interval;
    }
    getTotalBidData() {
        return this.totalBidData;
    }
    getDataSourceQS() {
        const source = this._filter.getDataSource();
        // temporary check to make sure we return the datasource string
        const ds = typeof source === "string" ? source : source.slug;
        return "data_source=" + ds + "&";
    }
    getDataSourceJSON() {
        const source = this._filter.getDataSource();
        // temporary check to make sure we return the datasource string
        const ds = typeof source === "string" ? source : source.slug;
        return { data_source: ds };
    }
    getClientTimezoneQS() {
        var tz = this._filter.getClientTimezone(); // +/-#### -0400
        var ret = "tz=" + tz + "&";
        return ret;
    }
    getClientTimezoneJSON() {
        var tz = this._filter.getClientTimezone(); // +/-#### -0400
        return { tz: tz };
    }
    getRollup() {
        return this.rollup.asObservable();
    }
    sendRollup(rollup) {
        this.rollup.next({ text: rollup });
    }
    setRollup() {
        return __awaiter(this, arguments, void 0, function* (interval = "hourly", dataSourceConnection = "data_store") {
            const userTzHour = this._filter.getClientTimezoneModifier();
            const nextRollup = yield this._rollup.getRolllupIntervalDate(interval, userTzHour, dataSourceConnection);
            this.rollup.next({ rollup: nextRollup });
        });
    }
    getExportedDataQS({ exportType = "xlsx", sortBy = "dfp_revenue", sortOrder = "desc", emailData = false, rowsLimit = null, } = {}) {
        let url = `${this.exportDataURL}?exportType=${exportType}&${this.buildBidDataQS()}`;
        if (sortBy)
            url += `&sortBy=${sortBy}`;
        if (sortOrder)
            url += `&sortOrder=${sortOrder}`;
        if (emailData)
            url += `&emailData=${!!emailData}`;
        if (rowsLimit)
            url += `&limit=${rowsLimit}`;
        return this._http
            .postCustomHeader(url, {}, { key: "adminrestrictdata", value: this._dataLevel.restrict() })
            .toPromise()
            .then((res) => res.json());
    }
    getExportedDataJSON({ exportType = "xlsx", sortBy = "dfp_revenue", sortOrder = "desc", emailData = false, rowsLimit = null, } = {}) {
        let params = this.buildBidDataJSON();
        if (exportType)
            Object.assign(params, { exportType: exportType });
        if (sortBy)
            Object.assign(params, { sortBy: sortBy });
        if (sortOrder)
            Object.assign(params, { sortOrder: sortOrder });
        if (emailData)
            Object.assign(params, { emailData: emailData });
        if (rowsLimit)
            Object.assign(params, { rowsLimit: rowsLimit });
        return this._http
            .postCustomHeader(this.createExportURL, params, {
            key: "adminrestrictdata",
            value: this._dataLevel.restrict(),
        })
            .toPromise()
            .then((res) => res.json());
    }
    getAdminRestrictDataParamQS(value = this._dataLevel.restrict()) {
        return `&adminrestrictdata=${value}`;
    }
    getAdminRestrictDataParamJSON(value = this._dataLevel.restrict()) {
        return { adminrestrictdata: value };
    }
    getHasHadData() {
        return this.hasHadData;
    }
    buildBidDataQS() {
        // NOTE: order should be maintained
        let params = this.getDataSourceQS() +
            this.getClientTimezoneQS() +
            this._filter.getBidDataFiltersQS() +
            this._filter.getGroupByColumnsQS() +
            this.getUniversalColumnsRequiredQS() +
            this._filter.getGroupByGroupsQS() +
            this.getAdminRestrictDataParamQS();
        console.log("QS: ", params);
        return params;
    }
    buildBidDataJSON() {
        let params = { data_source: undefined };
        let userPermissions = this._permission.get();
        Object.assign(params, this.getDataSourceJSON());
        if ((this._filter.getHelmDataSourcePermissions().filter((perm) => {
            userPermissions[perm];
        }).length > 0 &&
            params.data_source == "connect") ||
            (params.data_source == "rtbx" && this._filter.isHelmChecked())) {
            params.data_source = this._filter.getHelmDashboardDataSource().slug;
        }
        Object.assign(params, this.getClientTimezoneJSON());
        Object.assign(params, this.getBidDataFiltersJSON());
        Object.assign(params, this.getColumnsJSON());
        Object.assign(params, this.getGroupsJSON());
        Object.assign(params, this.getAdminRestrictDataParamJSON());
        Object.assign(params, this.getHelmJSON());
        return params;
    }
    getBidDataFiltersJSON() {
        return this._filter.getBidDataFiltersJSON();
    }
    getColumnsJSON() {
        let groupByColumns = this._filter.getGroupByColumnsJSON();
        let universalColumns = this.getUniversalColumnsRequiredJSON().filter((col) => !this._filter.isHelmChecked() ? col.indexOf("helm") === -1 : col);
        let columns = groupByColumns.concat(universalColumns);
        // Always include col parameter, even if empty, to match backend expectations
        // Backend will validate and return appropriate error if columns are invalid
        return { col: columns };
    }
    getGroupsJSON() {
        let groups = this._filter.getGroupByGroupsJSON();
        return groups.length ? { group: groups } : {};
    }
    getHelmJSON() {
        return this._filter.canToggleHelm() && this._filter.isHelmChecked()
            ? { helm: this._filter.isHelmChecked() }
            : {};
    }
    pullBidDataQS() {
        return this._http
            .get(`${this.bidDataURL}${this.buildBidDataQS()}`)
            .toPromise()
            .then((res) => {
            try {
                return res.json().data || {};
            }
            catch (err) {
                return {};
            }
        });
    }
    pullBidDataJSON() {
        return this._http
            .post(`${this.createQueryURL}`, this.buildBidDataJSON())
            .toPromise()
            .then((res) => {
            try {
                let response = res.json();
                this.csvWriter = response.csvWriter ? response.csvWriter : false;
                return response.data || {};
            }
            catch (err) {
                return {};
            }
        });
    }
    initChartData(totalsData = [], dataSeriesKeyName = "tz_datehour") {
        this.dashboardChart = [
            { id: "dfp_revenue", name: "Revenue", series: [] },
            { id: "renders", name: "Ad Renders", series: [] },
            { id: "ecpm", name: "Ad Renders eCPM", series: [] },
        ];
        for (let bidData of totalsData) {
            // insert series data value for each chart id
            for (let chartData of this.dashboardChart) {
                chartData.series.push({
                    name: bidData[dataSeriesKeyName],
                    value: Number(bidData[chartData.id] || bidData[`adjusted_${chartData.id}`]),
                });
            }
        }
    }
    formatBidData(bidData = [], metricsFormatters = {}) {
        return metricsFormatters && Object.keys(metricsFormatters).length
            ? // format the each bidData with appropiate metric formatter if present
                bidData.map((data) => Object.keys(data).reduce((formatted, key) => {
                    formatted[key] = metricsFormatters[key]
                        ? metricsFormatters[key](data[key])
                        : data[key];
                    return formatted;
                }, {}))
            : // No formatters available, return raw data
                bidData;
    }
    pull() {
        return __awaiter(this, void 0, void 0, function* () {
            const dataSource = this._filter.getDataSource();
            this.currentDataSource = dataSource;
            try {
                yield this._dataMetric.pull(dataSource.slug);
                const bidData = yield this.pullBidDataJSON();
                this.setRollup(this._filter.getInterval().toLowerCase(), this.currentDataSource.dataConnection);
                this.bidData = bidData.rows;
                this.hasHadData = this.bidData && this.bidData.length > 0;
                this.totalBidData = bidData.total || {};
                this.initChartData(bidData.datehour);
            }
            catch (err) {
                console.warn("BidData Pull Failed");
                // our callers should handle errors
                throw err;
            }
        });
    }
    handleBidDataRequestError(err, reloadDashboard = false, customMsg = "") {
        this.showQueryTimeoutAlertMsg = false;
        this.showCountsAlertMsg = false;
        if (this.isTimeoutError(err)) {
            this.showQueryTimeoutAlertMsg = true;
            this.showErrorAlert();
        }
        else if (this.isCountError(err) || this.isRangeError(err)) {
            this.showCountsAlertMsg = true;
            this.showErrorAlert();
        }
        else if (this.isMaxQueryCountError(err) &&
            this.parseBidDataError(err).showMaxQueryCountPopup) {
            this._talk.broadcast(this.parseBidDataError(err).message);
        }
        else {
            this._talk.broadcast(customMsg || "Oops! We had a problem loading the bid data.");
        }
        if (reloadDashboard)
            this.reloadDashboard();
    }
    showErrorAlert() {
        this.showQueryErrorAlert = true;
    }
    hideErrorAlert() {
        this.showQueryErrorAlert = false;
    }
    isTimeoutError(err) {
        return (err.status === 504 ||
            this.parseBidDataError(err).errorType === "DataQueryTimeout");
    }
    isMaxQueryCountError(err) {
        return this.parseBidDataError(err).errorType === "MAX_QUERY_COUNT_EXCEEDED";
    }
    isCountError(err) {
        return (this.parseBidDataError(err).errorType === "WEB_MAX_QUERY_COUNT_EXCEEDED");
    }
    isRangeError(err) {
        return this.parseBidDataError(err).message === "RangeError";
    }
    reloadDashboard() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this._router.navigate(["/dashboard/main"], {
                    queryParams: this._filter.getParsedQParams(),
                });
                this._loading.stop();
            }
            catch (err) {
                console.error("Unable to reload dashboard", err);
            }
        });
    }
    parseBidDataError(err) {
        try {
            return JSON.parse(err._body || {});
        }
        catch (err) {
            return err;
        }
    }
};
exports.BidDataService = BidDataService;
exports.BidDataService = BidDataService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        bid_data_filter_service_1.BidDataFilterService,
        data_level_service_1.DataLevelService,
        bid_data_rollup_service_1.BidDataRollupService,
        data_metric_service_1.DataMetricService,
        core_1.ApplicationRef,
        router_1.Router,
        permission_service_1.PermissionService,
        loading_service_1.LoadingService])
], BidDataService);
//# sourceMappingURL=bid-data.service.js.map